import ky from 'ky';

import getAccessToken from '../utils/get-access-token';
import { getCurrentCampaignId } from '../utils/get-campaign';

export const publicClient = ky.extend({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - import is used by vite
  prefixUrl: import.meta.env.VITE_API_URL,
});

export const privateClient = publicClient.extend({
  hooks: {
    beforeRequest: [
      (request) => {
        const accessToken = getAccessToken();
        const locale = localStorage.getItem('i18nextLng') || 'fr';

        request.headers.set('Content-Language', locale);

        if (accessToken) {
          request.headers.set('Authorization', `Token ${accessToken}`);
          // Get the current campaign ID (where is_current=True)
          const currentCampaignId = getCurrentCampaignId();
          if (currentCampaignId) {
            request.headers.set('X-Campaign-Year', String(currentCampaignId));
          }
        }
      },
    ],
  },
});
